import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';

export const isIOS =
  (/iPad|iPhone|iPod/.test(navigator.platform) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) &&
  !window.MSStream;

export const Option = isIOS ? ({ value, children }) => <option value={value}>{children}</option> : MenuItem;
